import React, { useEffect } from "react";
import RutesScreen from "./navigations/RutesScreen"
import { useDispatch } from "react-redux"
import { setToken } from "./redux/actions/action"
import { VERSION_APP_NATIVO, VERSION_CACHE } from "./api/Api";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    handleVersionApp();
    refreshCacheAndReload();
  }, []);


  //verifica el cache de la app, si hay una nueva version, la actualiza y borra el cache
  const refreshCacheAndReload = () => {
    // Verifica si hay una nueva version disponible y actualiza
    let version = localStorage.getItem('version');

    console.log('se actualiza cache====>', version, VERSION_CACHE.appVersion);
    if (version !== VERSION_CACHE.appVersion) {
      if (caches) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(function (names) {
          for (let name of names) caches.delete(name);
        });
      }
      // delete browser cache and hard reload
      window.location.reload(true);
      localStorage.setItem('version', VERSION_CACHE.appVersion);
      localStorage.removeItem('policy'); //se tiene que eliminar luego de actualizar el cache
    } else {
      console.log('no hay actualizacion');

    }


  }


  const handleVersionApp = () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'versionApp', data: VERSION_APP_NATIVO }));
    }
  }



  const dataLocalStorage = () => {
    let nameLocal = localStorage.getItem('dataUser');
    if (nameLocal) {
      // return JSON.parse(nameLocal);
      dispatch(setToken(JSON.parse(nameLocal)));
    } else {
      return null;
    }
  }

  useEffect(() => {
    dataLocalStorage();
  }, [])

  return (
    <RutesScreen />
  )
}

export default App